// extracted by mini-css-extract-plugin
module.exports = {"QrCodeModal":"Dialogs_QrCodeModal__2D1oz"};